import { render } from "./GroupDetail.vue?vue&type=template&id=20f51482&scoped=true"
import script from "./GroupDetail.vue?vue&type=script&lang=js"
export * from "./GroupDetail.vue?vue&type=script&lang=js"

import "./GroupDetail.vue?vue&type=style&index=0&id=20f51482&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f51482"]])

export default __exports__